import {
  Box,
  Flex,
  Grid,
  GridItem,
  Icon,
  Text,
  Tooltip
} from '@chakra-ui/react';
import { FiActivity } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

interface ActivityDay {
  date: string;
  count: number;
}

interface ActivityHeatmapProps {
  activityData: ActivityDay[];
  accentColor: string;
}

export const ActivityHeatmap = ({ activityData, accentColor }: ActivityHeatmapProps) => {
  const { t } = useTranslation(['v0/me']);

  return (
    <Box my={4}>
      <Flex align="center" mb={2}>
        <Icon as={FiActivity} mr={2} color={accentColor} />
        <Text fontWeight="medium">{t('v0/me:stats.activityHeatmap')}</Text>
      </Flex>
      <Grid templateColumns="repeat(7, 1fr)" gap={1}>
        {activityData.map((day, idx) => (
          <Tooltip
            key={idx}
            label={`${day.date}: ${day.count} ${t('v0/me:stats.tasks')}`}
            hasArrow
            placement="top"
          >
            <GridItem>
              <Box
                h="100%"
                minH="24px"
                bg={`${accentColor}`}
                opacity={day.count ? Math.min(0.2 + (day.count * 0.2), 1) : 0.1}
                borderRadius="sm"
                cursor="pointer"
              />
            </GridItem>
          </Tooltip>
        ))}
      </Grid>
      <Flex justify="space-between" mt={1}>
        <Text fontSize="xs" color="gray.500">{t('v0/me:stats.lastWeek')}</Text>
        <Text fontSize="xs" color="gray.500">{t('v0/me:stats.today')}</Text>
      </Flex>
    </Box>
  );
}; 